document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper !== 'undefined') {
      const swiper = new Swiper(".mySwiper", {
        slidesPerView: 1,
        loop: true,
        grabCursor: true,
     
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        }, 
        spaceBetween: 20,
        breakpoints: {
          767: {
            slidesPerView: 3,
          },
          
        },
      });
    }
  });